// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status-badge[data-v-8e6e4386] {\n  border: 1px solid;\n  border-color: var(--border-color);\n  border-radius: 19px;\n  background-color: var(--bg-color);\n  padding: 0px 5px;\n  display: inline-block;\n}\n.status-badge i[data-v-8e6e4386] {\n  color: var(--icon-color);\n}\n.status-badge span[data-v-8e6e4386] {\n  font-size: 1em;\n  color: var(--text-color);\n}", ""]);
// Exports
module.exports = exports;
